<template>
  <div class="dismissContainer">
    <div class="expiry-container position-relative pb-0 pt-0 pr-20 pl-20">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="widget-card p-0 cp cursor-pointer" @click="handlePopup">
            <div
              class="header d-flex flex-between align-items-center"
              :class="notificationClicked ? 'custom-border-0' : ''"
            >
              <div class="header-content d-flex align-items-center">
                <img class="triangle-alert" src="static/images/icons/alert_triangle_white.svg" />
                <h3 class="title fw-400">{{ serviceExpiryTitle }}</h3>
              </div>
              <div class="custom-arrow center rotate-180 cursor-pointer">
                <base-icon
                  icon="chevron_up_white"
                  :imgClass="notificationClicked ? 'full-width rotate-180' : 'full-width'"
                  @click="handlePopup"
                >
                </base-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="expiry-container position-relative pb-0 pt-0 pr-20 pl-20"
      v-if="notificationClicked"
    >
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-20 pl-20 expiry-div">
          <div class="widget-card p-0 custom-border">
            <div class="widget-container d-flex flex-between flex-direction-column">
              <div class="list-body">
                <section class="service-section" v-if="serviceExpirationList.length > 0">
                  <div class="list-accordion d-flex flex-between align-items-center">
                    <h4 class="list-header mb-0 mt-0">Services</h4>
                    <div
                      class="custom-arrow center rotate-180 cursor-pointer"
                      @click="handleServicesPopup"
                    >
                      <base-icon
                        icon="chevron_up_dark_blue"
                        :imgClass="serviceNotificationClicked ? 'rotate-180' : ''"
                      ></base-icon>
                    </div>
                  </div>
                  <ol class="list fw-400" v-if="serviceNotificationClicked">
                    <li v-for="(item, index) in serviceExpirationList" :key="index">
                      {{ item.name }} {{ getExpiryStatus(item.expiry_date) }} on
                      {{ item.expiry_date | UTCDate('MM/DD/YYYY') }}
                    </li>
                  </ol>
                </section>
                <hr v-if="projectExpirationList.length > 0 && serviceExpirationList.length > 0" />
                <section class="project-section" v-if="projectExpirationList.length > 0">
                  <div class="list-accordion d-flex flex-between align-items-center">
                    <h4 class="list-header mb-0 mt-0">Smart Builder Projects</h4>
                    <div
                      class="custom-arrow center rotate-180 cursor-pointer"
                      @click="handleprojectPopup"
                    >
                      <base-icon
                        icon="chevron_up_dark_blue"
                        :imgClass="projectNotificationClicked ? 'rotate-180' : ''"
                      ></base-icon>
                    </div>
                  </div>
                  <ol class="list fw-400" v-if="projectNotificationClicked">
                    <li v-for="(item, index) in projectExpirationList" :key="index">
                      {{ item.name }} {{ getExpiryStatus(item.expiry_date) }} on
                      {{ item.expiry_date | UTCDate('MM/DD/YYYY') }}
                    </li>
                  </ol>
                </section>
                <hr
                  v-if="
                    (projectExpirationList.length > 0 || serviceExpirationList.length > 0) &&
                    expiryAddOnList.length > 0
                  "
                />
                <section class="team-member-section" v-if="expiryAddOnList.length > 0">
                  <div class="list-accordion d-flex flex-between align-items-center">
                    <h4 class="list-header mb-0 mt-0">Team Members</h4>
                    <div
                      class="custom-arrow center rotate-180 cursor-pointer"
                      @click="handleExpiryPopup"
                    >
                      <base-icon
                        icon="chevron_up_dark_blue"
                        :imgClass="expiryNotificationClicked ? 'rotate-180' : ''"
                      ></base-icon>
                    </div>
                  </div>
                  <ol class="list fw-400" v-if="expiryNotificationClicked">
                    <li v-for="item in expiryAddOnList" :key="item.name + item.id">
                      The upgrade for "additional {{ item.name }} over 5" expires on
                      {{ item.expiry_date | UTCDate('MM/DD/YYYY') }}
                    </li>
                  </ol>
                </section>
              </div>
              <div class="row reminder-container pt-25 pb-30">
                <div class="col-xs-12 col-sm-6 col-md-6 p-0 custom-checkbox">
                  <div class="position-relative cust_checkbox">
                    <div class="checkbox inline-checkbox">
                      <label>
                        <input
                          type="checkbox"
                          v-model="checked" 
                        />
                        <span class="cr">
                        </span>
                      </label>
                    </div>
                    <span class="position-relative cursor-none"
                      >Do not show me these reminders again</span
                    >
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 buttons-group">
                  <el-popover
                    v-if="!(roleId === 1 || roleId === 5 || roleId === 9)"
                    class="cursor-pointer"
                    placement="top-start"
                    trigger="hover"
                    width="350"
                  >
                    <div class="limit_popover_txt">Account Owners can renew service</div>
                    <img
                      class="info-img"
                      src="/static/images/icons/info_icon.svg"
                      alt="info-icon"
                      slot="reference"
                    />
                  </el-popover>
                  <button
                    type="button"
                    @click="redirectToServices"
                    class="btn emergo-green-button renew-btn"
                    :disabled="!(roleId === 1 || roleId === 5 || roleId === 9)"
                  >
                    Renew
                  </button>
                  <a class="dismiss font-18 fw-500 cursor-pointer" @click="notificationDismiss"
                    >Dismiss</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import { Popover } from 'element-ui';
import EventBus from '../../utils/event-bus';
import { getUserData, getProfileData } from '../../apis/profile';
import { dismissExpiryBannerUsingPOST } from '../../apis/notification';

export default {
  props: [
    'projectExpirationList',
    'serviceExpirationList',
    'roleId',
    'expiryAddOnList',
    'account_id',
    'userId'
  ],
  components: {
    'el-popover': Popover
  },
  data() {
    return {
      serviceExpiryTitle: 'Service(s)\nExpiring Soon',
      notificationClicked: false,
      serviceNotificationClicked: true,
      projectNotificationClicked: false || Boolean(this.serviceExpirationList <= 0),
      expiryNotificationClicked: Boolean(
        this.serviceExpirationList.length <= 0 && this.projectExpirationList.length <= 0
      ),
      checked: false,
      userData: {}
    };
  },
  methods: {
    getExpiryStatus(date) {
      if (date) return moment(date).isBefore(moment(), 'day') ? 'expired' : 'expires';
      return false;
    },
    async notificationDismiss() {
      const profileData = localStorage.getItem('profileData')
        ? JSON.parse(localStorage.getItem('profileData'))
        : await getProfileData();
      if (this.checked === true && this.userData.id === profileData.id) {
        this.dismissExpiryBannerUsingPOST();
      }
      sessionStorage.setItem('dismissPopup', true);
      $('.dismissContainer').css('display', 'none');
    },
    async dismissExpiryBannerUsingPOST() {
      const planIds = [];
      this.projectExpirationList.forEach((c) => {
        planIds.push(c.id);
      });
      this.serviceExpirationList.forEach((c) => {
        planIds.push(c.id);
      });
      const addonIds = [];
      this.expiryAddOnList.forEach((c) => {
        addonIds.push(c.id);
      });
      const payloadBody = {
        account_id: this.userData.account_id,
        add_on: addonIds,
        plan: planIds,
        user_id: this.userData.id
      };
      await dismissExpiryBannerUsingPOST(payloadBody);
    },
    /*
    redirectToServices() is used to open the services popup
    */
    redirectToServices() {
      EventBus.$emit('openAccountSettingsPopup', 'services');
      this.notificationClicked = false;
    },
    handlePopup(event) {
      event.stopPropagation();
      this.notificationClicked = !this.notificationClicked;
    },
    handleServicesPopup(event) {
      event.stopPropagation();
      this.serviceNotificationClicked = !this.serviceNotificationClicked;
    },
    handleprojectPopup(event) {
      event.stopPropagation();
      this.projectNotificationClicked = !this.projectNotificationClicked;
    },
    handleExpiryPopup(event) {
      event.stopPropagation();
      this.expiryNotificationClicked = !this.expiryNotificationClicked;
    }
  },
  async mounted() {
    this.userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
    const dismissPopup = sessionStorage.getItem('dismissPopup');
    if (dismissPopup) {
      $('.dismissContainer').css('display', 'none');
    }
  },
  filters: {
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    }
  }
};
</script>
<style lang="scss" scoped>
.expiry-container {
  font-family: Roboto;
  font-style: normal;
  height: 100%;
  background: #f2f2f2;
  padding-left: 24px;
  padding-right: 24px;

  .widget-card {
    background: $white;
    border-radius: $radius10;

    .header {
      background: $deep-thick-danger;
      border: 1px solid $deep-thick-danger;
      box-sizing: border-box;
      border-radius: 0px 0px 10px 10px;
      min-height: 45px;
      padding-right: 32px;
      padding-left: 32px;
      .header-content {
        img.triangle-alert {
          margin-right: 15px;
        }

        .title {
          margin: unset;
          font-family: Roboto;
          color: $white;
          line-height: 28px;
          font-size: $font-24 !important;
        }
      }
    }
    &.custom-border {
      border-radius: 0px 0px 10px 10px;
      box-shadow: $tertiary-box-shadow;
    }

    .widget-container {
      height: 373px;

      .list-body {
        padding-left: 30px;
        min-height: 50px;
        overflow-y: scroll;
        border-top: 1px solid #f2f2f2;
        box-sizing: border-box;
        border-radius: 0px 0px 10px 10px;
        padding-top: 22px;
        padding-right: 10px;

        .custom-arrow {
          margin-bottom: unset;
          margin-right: 15px;
        }

        hr {
          width: 97%;
        }
        .service-section {
          margin-bottom: 6px;
        }
        .list-header {
          margin-left: 18px;
          color: rgba(0, 0, 0, 0.7);
        }

        .list {
          font-family: Roboto;
          font-style: normal;
          margin-top: 12px;
          margin-left: 10px;
          color: rgba(0, 0, 0, 0.7);
          font-size: $font-16;
          font-weight: $font-weight-400;
          line-height: 25px;
          min-height: 50px;
          overflow-y: auto;
        }
      }

      @-moz-document url-prefix() {
        .list-body {
          scrollbar-width: thin;
          .custom-arrow {
            margin-bottom: unset;
            margin-right: 15px !important;
          }
        }
      }
      .reminder-container {
        padding-right: 32px;
        display: flex;
        .cust_checkbox {
            margin-right: 8px;
            margin-top:10px;
            padding-left: 56px;
            span {
            color: rgba(0, 0, 0, 0.7);
            font-size: $font-14;
            }
            .cursor-none {
              cursor: none;
            }
        }
        .buttons-group {
          text-align: right;
          padding-right: 20px;
          .renew-btn {
            width: 160px;
            margin-right: 24px;
          }
          .dismiss {
            font-family: Roboto;
            font-style: normal;
            color: $primary;
            position: relative;
            top: 2px;
          }
        }
      }
    }

    .custom-arrow {
      width: 24px;
      height: 24px;
      img {
        width: 100%;
      }
    }
  }

  .expiry-div {
    position: absolute;
    z-index: 1;
    min-height: 25px;
    left: 0;
    padding-left: 24px;
    padding-right: 24px;
  }
  .custom-border-0 {
    border-radius: $radius0 !important;
  }
}

@media only screen and (max-width: 1024px) and (min-width: 680px) {
  .expiry-container {
    .widget-card {
      .header {
        padding-left: 24px;
        padding-right: 24px;
      }
      .widget-container {
        .list-body {
          padding-right: 19px;

          .custom-arrow {
            margin-bottom: unset;
            margin-right: -2px;
          }
        }
        @-moz-document url-prefix() {
          .list-body {
            .custom-arrow {
              margin-right: 7px !important;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 679px) {
  .expiry-container {
    .widget-card {
      .header {
        padding-right: 24px;
        padding-left: 24px;
        .header-content {
          margin-top: 7px;
          margin-bottom: 7px;
          img.triangle-alert {
            margin-bottom: 20px;
          }
          .title {
            font-size: $font-24 !important;
            white-space: break-spaces;
            line-height: 28.13px;
          }
        }
      }

      .custom-arrow {
        margin-bottom: 20px;
        position: relative;
        right: 1px;
      }

      .widget-container {
        .list-body {
          padding-right: 0px;
          padding-top: 24px;
          .custom-arrow {
            margin-bottom: unset;
            margin-right: 17px;
          }
          .list-header {
            margin-left: 5px;
            line-height: 21.09px;
          }
          .list {
            font-size: $font-16;
            margin-left: 5px;
            padding-left: 30px;
            padding-right: 20px;
          }
        }

        @-moz-document url-prefix() {
          .list-body {
            .custom-arrow {
              margin-right: 25px !important;
            }
          }
        }
        .reminder-container {
          padding-right: 0px;
          flex-direction: column;

          .custom-checkbox {
            padding-left: 50px;
            text-align: left;
            .cust_checkbox {
              margin-bottom: 25px;
              padding-left: 0px;
              span {
                font-size: $font-14;
              }
            }
          }
          .buttons-group {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-right: 15px;
            text-align: center;

            button.renew-btn {
              width: 82%;
              margin: 24px;
              margin-top: 0px;
            }
          }
        }
      }
    }
  }
}
</style>
